import { defineStore } from 'pinia'
import type {
  PrideEntry,
  Review,
  StoreReview,
  StoreTrainingSignupRequest,
  TrainerDetails,
} from '~/api'

export const useTrainerStore = defineStore('trainerStore', () => {
  const api = useApi()

  const pageData = ref<TrainerDetails | null>(null)
  const prideEntries = ref<PrideEntry[]>([])

  const directions = computed(() => pageData.value?.directions || [])
  const lessonTypes = computed(() => pageData.value?.lesson_types || [])
  const gallery = computed(() => pageData.value?.gallery || [])

  const reviews = ref<Review[]>([])

  const fetchTrainer = async (id: string) => {
    pageData.value = (await api.public['trainers.detail'](id)).data
  }

  const fetchReviews = async (id: string) => {
    reviews.value = (await api.public.trainerReviews(id)).data
  }

  const fetchPrideEntries = async (id: string) => {
    prideEntries.value = (await api.public.trainerPrideEntries(id)).data
  }

  const storeReview = async (id: string, data: StoreReview) => {
    await api.public.storeTrainerReview(id, data)
  }

  const trainingSignup = async (
    id: string,
    data: StoreTrainingSignupRequest,
  ) => {
    await api.public.trainingSignupRequestsStoreTrainer(id, data)
  }

  return {
    pageData,
    directions,
    lessonTypes,
    gallery,
    prideEntries,
    reviews,

    fetchTrainer,
    fetchReviews,
    fetchPrideEntries,
    storeReview,
    trainingSignup,
  }
})
